import { FunnelImage, LoaderName } from '../Content';
import { BaseScreenAttributes } from './BaseScreenAttributes';
import { ScreenType } from './ScreenType';

type GalaxyLoader = {
  type: LoaderName.GALAXY;
  image: FunnelImage;
};

type Loader = GalaxyLoader;

export const OnboardingLogoVariant = {
  NEBULA_MONO: 'nebulaMono',
} as const;

export type OnboardingLogoVariant =
  (typeof OnboardingLogoVariant)[keyof typeof OnboardingLogoVariant];

export type OnboardingLogo = {
  variant: OnboardingLogoVariant;
  alt: string;
};

export type OnboardingSlide = {
  loader?: Loader;
  logo?: OnboardingLogo;
  title?: string;
  text?: string;
  image?: FunnelImage;
  delayMs?: number;
};

export interface NebOnboardingScreenAttributes extends BaseScreenAttributes {
  content: {
    startDelayMs?: number;
    transitionDelayMs?: number;
    list: OnboardingSlide[];
  };
  screenType: ScreenType.NEB_ONBOARDING;
}
